type TGetCurrentStep = {
  queryStep?: number;
  hasReloadedData?: boolean;
  numberOfCompletedSteps?: number;
  currentStep?: number;
  amountOfSteps: number;
};

/**
 * https://www.figma.com/file/TUjQJqIVZQHfbSEwwnpggk/Form-V2-Field-States?type=whiteboard&node-id=181%3A420&t=CAjGcL9iPo9Uneek-1
 */
const getCurrentStep = ({
  queryStep = undefined,
  hasReloadedData = false,
  numberOfCompletedSteps = 0,
  currentStep,
  amountOfSteps,
}: TGetCurrentStep) => {
  if (!queryStep && !currentStep && !hasReloadedData) return 1;

  const isLastStepCompleted = numberOfCompletedSteps === amountOfSteps;

  if (hasReloadedData) {
    const firstIncompleteStep = numberOfCompletedSteps + 1;

    if (!queryStep) {
      return isLastStepCompleted ? amountOfSteps : firstIncompleteStep;
    }

    if (queryStep <= firstIncompleteStep && !isLastStepCompleted)
      return queryStep;

    if (isLastStepCompleted) {
      return queryStep > amountOfSteps ? amountOfSteps : queryStep;
    }

    return firstIncompleteStep;
  }

  if (queryStep) {
    if (!currentStep) return 1;

    if (currentStep > queryStep) {
      return queryStep;
    }

    return currentStep;
  }

  if (!currentStep) return 1;

  if (currentStep <= amountOfSteps) {
    return currentStep;
  }

  return 1;
};

export default getCurrentStep;
